<app-header />

<div class="tw-max-w-6xl">
  <importer-shell-progress />

  <router-outlet></router-outlet>
</div>
